import { render, staticRenderFns } from "./geofence.vue?vue&type=template&id=5a3ee5a9&"
import script from "./geofence.vue?vue&type=script&lang=js&"
export * from "./geofence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports